module.exports = __webpack_public_path__ + "static/img/intru1.28f6ae4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru1.jpg
// module id = s5EN
// module chunks = 0